<template>
  <section class="new-user">
    <h2>{{ $t('New user?') }}</h2>
    <p>
      {{
        $t(
          'View future bookings, save favourites, add reviews, get directions, book again and find out how to cancel or change your booking.',
        )
      }}
    </p>
    <br />
    <nuxt-link
      :to="$puLocalePath({ name: 'accounts-signup' })"
      class="button alt asblock"
    >
      {{ $t('Sign up') }}
    </nuxt-link>
  </section>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class NewUser extends Vue {}

export default toNative(NewUser)
</script>

<style scoped>
section {
  background: var(--colour-mid-blue);
  color: white;
  margin-top: 2em;
  padding: 1.5em 1.5em 16em;
  flex-grow: 1;
}
</style>
